import { render, staticRenderFns } from "./MaxxFormDisplay.vue?vue&type=template&id=8554cf40&scoped=true&"
import script from "./MaxxFormDisplay.vue?vue&type=script&lang=js&"
export * from "./MaxxFormDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8554cf40",
  null
  
)

export default component.exports